import { localizedNeedLoginPath } from '~/utils/common'

export function useLogin() {
  const { $request } = useNuxtApp()
  const isExpired = useState('is-expired', () => false)
  const visible = useState('login-visible', () => false)
  const route = useRoute()
  const user = useUser()
  function toggleDialog(val: boolean) {
    visible.value = val
  }
  watch(() => user.value.info, (val) => {
    const moduleInfo = val?.privileges?.find((item: any) => item.moduleId === '1')
    isExpired.value = !val.id ? false : !val.privileges?.length || !moduleInfo?.privilegeValue
  }, { immediate: true })

  async function refetchUserInfo() {
    await useRequest<Api.User.Info>('/user/info', { key: 'userInfo' })
  }
  const isExpiredOrUnLogin = computed(() => !user.value.isLogin || isExpired.value)
  async function logout() {
    try {
      await $request<any>('/user/logout')
      refetchUserInfo()
      const localePath = useLocalePath()
      if (localizedNeedLoginPath().includes(route.path)) {
        navigateTo(localePath('/analysis/products'))
      }
    }
    catch (e) {
      console.error(e)
    }
  }

  return {
    visible,
    isExpired,
    isExpiredOrUnLogin,
    logout,
    toggleDialog,
    refetchUserInfo,
  }
}
